<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="14">
                <el-card>
                    <el-row>
                        <el-col style="padding: 10px 0 20px">
                            <!-- <span>门店档案列表</span> -->
                            <el-button
                                type="danger"
                                size="mini"
                                icon="el-icon-delete"
                                class="pull-right"
                                @click="deleteBatch"
                                >批量删除</el-button
                            >
                            <el-button
                                class="pull-right right-10"
                                icon="el-icon-upload"
                                type="primary"
                                size="mini"
                                @click="importFile()"
                                >批量导入</el-button
                            >
                            <el-button
                                class="pull-right"
                                icon="el-icon-download"
                                type="primary"
                                size="mini"
                                @click="
                                    downloadFile(`${moduleName}${basicType}`)
                                "
                                >模板下载</el-button
                            >
                            <el-button
                                class="pull-right"
                                icon="el-icon-download"
                                type="primary"
                                size="mini"
                                @click="downLoadExcel()"
                                >导出Excel</el-button
                            >
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addRow"
                                >新增</el-button
                            >
                            <div class="pull-right">
                                <el-input
                                    placeholder="请输入编码,名称"
                                    prefix-icon="el-icon-search"
                                    v-model="FinQueryParams.archiveFilter"
                                    size="mini"
                                ></el-input>
                            </div>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="FinTableData"
                        size="mini"
                        style="width: 100%"
                        border
                        ref="FinTableData"
                        @select="tableSelectHandler"
                        @select-all="tableSelectAllHandler"
                        :row-key="getRowKeys"
                        @selection-change="handleSelectionChange"
                    >
                        <el-table-column
                            type="selection"
                            width="55"
                            :reserve-selection="true"
                        ></el-table-column>

                        <el-table-column label="操作" width="160">
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="top">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="editRow(scope.row)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="top">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="deleteRow(scope.row._id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <template v-for="(item, index) in finFieldsList">
                            <el-table-column
                                :label="`${item}编码`"
                                :prop="'finCode' + (Number(index) + 1)"
                            ></el-table-column>
                            <el-table-column
                                :label="`${item}名称`"
                                :prop="'finName' + (Number(index) + 1)"
                            ></el-table-column>
                        </template>
                        <template v-for="(item, index) in sourceFieldsList">
                            <el-table-column
                                :label="`${moduleName}${item}编码`"
                                :prop="'posCode' + (Number(index) + 1)"
                            ></el-table-column>
                            <!-- <el-table-column
                                :label="`${moduleName}${item}名称`"
                                prop=""
                            ></el-table-column> -->
                        </template>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="GetFinDataUrl"
                        :GetData="InitFinData"
                        :queryParam="FinQueryParams"
                        :isInit="true"
                        :errorFunc="CloseError"
                        size="mini"
                    ></pagerBar>
                </el-card>
            </el-col>
            <el-col :span="10">
                <el-card>
                    <el-row>
                        <el-col style="padding: 10px 0 20px">
                            <span>{{ this.moduleName }}源数据</span>
                            <div class="pull-right">
                                <el-input
                                    placeholder="请输入编码,名称"
                                    prefix-icon="el-icon-search"
                                    v-model="QueryParams.filter"
                                    size="mini"
                                ></el-input>
                            </div>
                        </el-col>
                    </el-row>
                    <el-table
                        :data="CloudTableData"
                        size="mini"
                        style="width: 100%"
                        border
                    >
                        <el-table-column
                            prop="code"
                            v-if="formLabel.code == '餐饮客户'"
                            label="客户编码"
                        ></el-table-column>
                        <el-table-column
                            prop="name"
                            v-if="formLabel.code == '餐饮客户'"
                            label="客户名称"
                        ></el-table-column>
                        <el-table-column
                            prop="shopId"
                            v-if="formLabel.code == '餐饮客户'"
                            label="门店编码"
                        ></el-table-column>
                        <el-table-column
                            prop="shopName"
                            v-if="formLabel.code == '餐饮客户'"
                            label="门店名称"
                        ></el-table-column>
                        <el-table-column
                            prop="code"
                            v-if="formLabel.code != '餐饮客户'"
                            :label="`${formLabel.sourceDataFieldName}编码`"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="name"
                            v-if="formLabel.code != '餐饮客户'"
                            :label="`${formLabel.sourceDataFieldName}名称`"
                        ></el-table-column>

                        <el-table-column
                            prop="typeCode"
                            v-if="formLabel.code == '餐饮品项分类'"
                            label="品牌编码"
                        >
                        </el-table-column>
                        <el-table-column
                            prop="typeName"
                            v-if="formLabel.code == '餐饮品项分类'"
                            label="品牌名称"
                        ></el-table-column>
                    </el-table>
                    <pagerBar
                        ref="cloundApiUrl"
                        :apiURL="GetCloudDataUrl"
                        :GetData="InitCloudData"
                        :queryParam="QueryParams"
                        :isInit="true"
                        :errorFunc="CloseError"
                        size="mini"
                    ></pagerBar>
                    <el-table
                        id="cloudData"
                        size="mini"
                        hidden
                        :data="basicCloudData"
                        ref="detail"
                    >
                        <template v-for="(item, index) in finFieldsList">
                            <el-table-column
                                :label="`${item}编码`"
                            ></el-table-column>
                            <el-table-column
                                :label="`${item}名称`"
                            ></el-table-column>
                        </template>
                        <template v-for="(item, index) in sourceFieldsList">
                            <el-table-column
                                :label="`${moduleName}${item}编码`"
                            ></el-table-column>
                            <!-- <el-table-column
                                :label="`${moduleName}${item}名称`"
                                prop=""
                            ></el-table-column> -->
                        </template>
                    </el-table>
                </el-card>
            </el-col>
        </el-row>
        <!-- 批量导入Dialog开始 -->
        <uploadTemp
            :apiURL="fileUploadUrl"
            ref="refFileUpload"
            :Refresh="Refresh"
            :OtherParams="{
                brandId: QueryParams.BrandID,
                typeName: this.moduleName + this.basicType,
                FieldName: this.QueryParams.FieldName,
                BasicId: this.QueryParams.BasicId
            }"
        ></uploadTemp>
        <!-- 批量导入Dialog结束 -->
        <!-- 数据新增Dialog开始-->
        <el-dialog
            v-el-drag-dialog
            :title="xtitle"
            :visible.sync="formVisible"
            width="35%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form
                :label-position="labelPosition"
                label-width="150px"
                :model="RowModel"
                ref="refMaterielForm"
            >
                <template v-for="(item, index) in finFieldsList">
                    <el-form-item
                        :label="`${item}编码`"
                        :prop="'finCode' + (Number(index) + 1)"
                        :rules="[
                            {
                                type: 'string',
                                required: true,
                                message: '请输入' + item + '编码'
                            }
                        ]"
                    >
                        <el-input
                            v-model="RowModel['finCode' + (Number(index) + 1)]"
                            :placeholder="`请输入${item}编码`"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        :label="`${item}名称`"
                        :prop="'finName' + (Number(index) + 1)"
                        :rules="[
                            {
                                type: 'string',
                                required: true,
                                message: '请输入' + item + '名称'
                            }
                        ]"
                    >
                        <el-input
                            v-model="RowModel['finName' + (Number(index) + 1)]"
                            :placeholder="`请输入${item}名称`"
                        ></el-input>
                    </el-form-item>
                </template>

                <template v-for="(item, index) in sourceFieldsList">
                    <el-form-item
                        :label="`${moduleName}${item}编码`"
                        :prop="'posCode' + (Number(index) + 1)"
                        :rules="[
                            {
                                type: 'string',
                                required: true,
                                message: '请输入' + moduleName + item + '编码'
                            }
                        ]"
                    >
                        <el-input
                            v-model="RowModel['posCode' + (Number(index) + 1)]"
                            :placeholder="`请输入${moduleName}${item}编码`"
                        ></el-input>
                    </el-form-item>
                    <!-- <el-form-item
                        :label="`${moduleName}${item}名称`"
                        :prop="'posName' + (Number(index) + 1)"
                        :rules="[
                            {
                                type: 'string',
                                required: true,
                                message: '请输入' + moduleName + item + '名称',
                            },
                        ]"
                    >
                        <el-input
                            v-model="RowModel['posName' + (Number(index) + 1)]"
                            :placeholder="`请输入${moduleName}${item}名称`"
                        ></el-input>
                    </el-form-item> -->
                </template>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="info"
                    size="medium"
                    @click="formVisible = false"
                    icon="el-icon-close"
                    >取 消</el-button
                >
                <el-button
                    type="primary"
                    size="medium"
                    @click="saveRow"
                    icon="el-icon-check"
                    >保 存</el-button
                >
            </span>
        </el-dialog>
        <!-- 数据新增Dialog结束 -->
    </div>
</template>
<script>
import config from '@/common/config.js'
import AjaxHelper from '@/common/js/AjaxHelper'
import pagerBar from '@/views/pager/pagerBar'
import uploadTemp from '@/views/batchUploadTemp/uploadTemp'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
    components: {
        pagerBar,
        uploadTemp
    },
    data() {
        return {
            isExtendCol: false,
            basicCloudData: [],
            //财务基础档案
            FinTableData: [],
            //云餐饮基础档案
            CloudTableData: [],
            GetCloudDataUrl: config.BASE_Middle_API + 'PosShop/GetAll',
            GetFinDataUrl: config.BASE_Middle_API + 'PosCommon/GetAll',
            ApiUrl: config.BASE_Middle_API + 'PosCommon',
            fileUploadUrl: config.BASE_Middle_API + 'PosCommon/UploadFiles',
            downLoadUrl: config.BASE_Middle_API + 'PosCommon/DownloadFiles',
            downLoadExcelUrl: config.BASE_Middle_API + 'PosCommon/ExcelOutPut',
            QueryParams: {
                BrandID: this.$route.query.brandId,
                FieldName: '',
                BasicId: this.$route.query.code,
                tableName: ''
            },
            FinQueryParams: {
                BrandID: this.$route.query.brandId,
                FieldName: '',
                BasicId: this.$route.query.code
            },
            basicType: this.$route.query.id,
            moduleName: this.$route.query.module,
            RowModel: {},
            labelPosition: 'left',
            handleClose(d) {
                d()
            },
            xtitle: '',
            formVisible: false,
            selOrder: [],
            selOrderIds: [],
            formLabel: {},
            finFieldsList: [],
            sourceFieldsList: [],
            deleteUrl:
                config.BASE_Middle_API + 'PosShop/ChangeBasicDataInfoRecords'
        }
    },
    props: {
        openloading: {
            type: Function,
            required: true
        },
        closeloading: {
            type: Function,
            required: true
        }
    },
    created: function () {
        this.getName()
    },
    mounted: function () {},
    methods: {
        getCurrentEntity() {
            const _this = this
            AjaxHelper.get(
                _this.ApiUrl +
                    '/GetBasicDataForEdit?id=' +
                    _this.$route.query.code
            )
                .then(function (response) {
                    if (response.success) {
                        _this.formLabel = response.result.basicData
                        if (_this.formLabel.finFields) {
                            _this.finFieldsList = [
                                ..._this.formLabel.finFields
                                    .split(',')
                                    .map((x) => {
                                        return x
                                    })
                            ]
                        }
                        if (_this.formLabel.sourceFields) {
                            _this.sourceFieldsList = [
                                ..._this.formLabel.sourceFields
                                    .split(',')
                                    .map((x) => {
                                        return x
                                    })
                            ]
                        }
                        _this.QueryParams.FieldName = _this.formLabel.code
                        _this.FinQueryParams.FieldName = _this.formLabel.code
                        _this.QueryParams.tableName =
                            _this.formLabel.souceTableName
                    }
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        getName() {
            this.getCurrentEntity()

            // switch (this.basicType) {
            //     case "多组织档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "组织";
            //         this.cloudlabelText = "组织";
            //         this.QueryParams.FieldName = "餐饮组织";
            //         this.FinQueryParams.FieldName = "餐饮组织";
            //         break;
            //     case "银行账户档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "银行账户";
            //         this.cloudlabelText = "银行账户";
            //         this.isExtendCol = true;
            //         this.cloudlabelExtendText = "门店";
            //         this.QueryParams.FieldName = "餐饮银行账户";
            //         this.FinQueryParams.FieldName = "餐饮银行账户";
            //         break;
            //     case "部门档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "部门";
            //         this.cloudlabelText = "部门";
            //         this.QueryParams.FieldName = "餐饮部门";
            //         this.FinQueryParams.FieldName = "餐饮部门";
            //         break;
            //     case "客户档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "客户";
            //         this.cloudlabelText = "客户";
            //         this.QueryParams.FieldName = "餐饮客户";
            //         this.FinQueryParams.FieldName = "餐饮客户";
            //         break;
            //     case "品项档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "品项";
            //         this.cloudlabelText = "品项";
            //         this.QueryParams.FieldName = "餐饮品项";
            //         this.FinQueryParams.FieldName = "餐饮品项";
            //         break;
            //     case "品项分类档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "品项分类";
            //         this.cloudlabelText = "品项分类";
            //         this.QueryParams.FieldName = "餐饮品项分类";
            //         this.FinQueryParams.FieldName = "餐饮品项分类";
            //         break;
            //     case "品项分类门店档案":
            //         this.moduleName = "餐饮";
            //         this.isExtendCol = true;
            //         this.labelText = "门店";
            //         this.cloudlabelText = "品项分类";
            //         this.QueryParams.FieldName = "餐饮品项分类门店";
            //         this.FinQueryParams.FieldName = "餐饮品项分类门店";
            //         this.z5labelExtendText = "门店";
            //         break;
            //     case "供应商档案":
            //         this.isExtendCol = true;
            //         this.moduleName = "餐饮";
            //         this.labelText = "供应商";
            //         this.cloudlabelExtendText = "门店";
            //         this.cloudlabelText = "供应商";
            //         this.QueryParams.FieldName = "餐饮供应商";
            //         this.FinQueryParams.FieldName = "餐饮供应商";
            //         break;
            //     case "结算方式费用类型档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "费用类型";
            //         this.cloudlabelText = "结算方式";
            //         this.QueryParams.FieldName = "餐饮结算方式费用类型";
            //         this.FinQueryParams.FieldName = "餐饮结算方式费用类型";
            //         break;
            //     case "结算方式档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "结算方式";
            //         this.cloudlabelText = "结算方式";
            //         this.QueryParams.FieldName = "餐饮结算方式";
            //         this.FinQueryParams.FieldName = "餐饮结算方式";
            //         break;
            //     case "部门结算方式档案":
            //         this.moduleName = "餐饮";
            //         this.labelText = "部门";
            //         this.cloudlabelText = "结算方式";
            //         this.QueryParams.FieldName = "餐饮部门结算方式";
            //         this.FinQueryParams.FieldName = "餐饮部门结算方式";
            //         break;
            // }
        },
        getRowKeys(row) {
            return row._id
        },
        handleSelectionChange(val) {
            // this.multipeleSelectedIds = val;
            const _this = this
            let b = false
            _this.selOrder.forEach((item) => {
                if (item.key == _this.$refs.refPagerBar.currentPage) {
                    b = true
                    item.value = val
                }
            })
            if (!b) {
                _this.selOrder.push({
                    key: _this.$refs.refPagerBar.currentPage,
                    value: val
                })
            }
        },
        // 选中table已有数据
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$nextTick(() => {
                        let checked = this.FinTableData.find(
                            (tableRow) => tableRow._id === row._id
                        )
                        this.$refs.FinTableData.toggleRowSelection(checked)
                    })
                })
            } else {
                this.$refs.FinTableData.clearSelection()
            }
        },
        tableSelectHandler(selection, row) {
            const _this = this
            let allRows = selection.filter((item) => !!item)
            if (allRows.find((item) => item._id === row._id)) {
                _this.addRows([row])
            } else {
                _this.removeRows([row])
            }
        },
        addRows(rows) {
            const _this = this
            for (let key of rows) {
                if (!_this.selOrder.find((item) => item._id === key._id)) {
                    this.selOrder.push(key)
                }
            }
        },
        // 取消选中行
        removeRows(rows) {
            const _this = this
            if (_this.selOrder.length > 0) {
                for (let row of rows) {
                    _this.selOrder = _this.selOrder.filter(
                        (item) => item._id !== row._id
                    )
                }
            }
        },
        tableSelectAllHandler(selection) {
            //删除undefined 也就是表头的checkbox的数据 否则翻页全选不会取消
            selection.forEach((e, index) => {
                if (e === undefined) {
                    selection.splice(index, 1)
                }
            })
            // 如果有则是全选否则就是全取消
            if (selection.length > 0) {
                this.addRows(this.FinTableData)
            } else {
                this.removeRows(this.FinTableData)
            }
        },
        deleteBatch() {
            const _this = this
            _this.selOrderIds = []
            _this.selOrder.forEach((item) => {
                if (item.value != null && item.value.length > 0) {
                    item.value.forEach((v) => {
                        _this.selOrderIds.push(v._id)
                    })
                }
            })
            if (_this.selOrderIds.length == 0) {
                this.$notify({
                    title: '提示',
                    message: '请先勾选需要删除的单据',
                    type: 'error',
                    position: 'bottom-right'
                })
                return
            }
            this.$confirm('此操作将删除已勾选的基础信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    AjaxHelper.post(_this.deleteUrl, {
                        brandID: _this.QueryParams.BrandID,
                        FieldName: _this.QueryParams.FieldName,
                        orderIds: _this.selOrderIds,
                        BasicId: Number(_this.$route.query.code),
                        sourceTableName: _this.QueryParams.souceTableName
                    })
                        .then(function (r) {
                            if (r.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                })
                                _this.$refs.FinTableData.clearSelection()
                                _this.$refs.refPagerBar.Refresh()
                            }
                        })
                        .catch((e) => {
                            _this.$message({
                                type: 'info',
                                message: e.message
                            })
                        })
                })
                .catch((e) => {
                    _this.$message({
                        type: 'info',
                        message: e.message
                    })
                })
        },

        InitCloudData(data) {
            this.CloudTableData = data
            this.closeloading()
        },
        InitFinData(data) {
            this.FinTableData = data
            this.closeloading()
        },
        CloseError() {
            this.closeloading()
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh()
        },
        initModel() {
            const _this = this
            if (_this.$refs['refMaterielForm']) {
                _this.$refs['refMaterielForm'].resetFields()
                _this.RowModel = {
                    id: 0
                }
            }
        },

        addRow() {
            this.initModel()
            this.xtitle = '新增' + this.moduleName + '对照'
            this.formVisible = true
            this.operation = 'Add'
        },
        editRow(row) {
            const _this = this
            _this.initModel()
            _this.xtitle = '编辑' + this.moduleName + '对照'
            _this.operation = 'Edit'
            _this.RowModel = Object.assign({}, row)
            _this.formVisible = true
        },

        saveRow() {
            //提交保存
            const _this = this
            this.$refs['refMaterielForm'].validate((valid) => {
                if (valid) {
                    let postUrl = ''
                    if (_this.operation == 'Add') {
                        postUrl = '/Add'
                    } else {
                        postUrl = '/Edit'
                    }
                    _this.RowModel.brandId = _this.QueryParams.BrandID
                    _this.RowModel.ModuleID = _this.$route.query.moduleID
                    _this.RowModel.BasicId = Number(_this.$route.query.code)
                    _this.RowModel.tempId = _this.RowModel._id
                    _this.RowModel.typeName = _this.QueryParams.FieldName
                    if (_this.RowModel.z5CloudExtendCode == null) {
                        _this.RowModel.z5CloudExtendCode = ''
                    }
                    AjaxHelper.post(_this.ApiUrl + postUrl, _this.RowModel)
                        .then(function (response) {
                            if (response.success) {
                                _this.$notify({
                                    title: '成功',
                                    message: '操作成功',
                                    type: 'success',
                                    position: 'bottom-right'
                                })
                                _this.formVisible = false
                                _this.initModel()
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {})
                }
            })
        },
        deleteRow(id) {
            const _this = this
            this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    _this.RowModel.typeName = _this.QueryParams.FieldName
                    _this.RowModel.brandId = _this.QueryParams.BrandID
                    _this.RowModel.tempId = id
                    _this.RowModel.BasicId = Number(_this.$route.query.code)
                    AjaxHelper.delete(_this.ApiUrl + '/Delete', _this.RowModel)
                        .then(function (response) {
                            if (response.success) {
                                _this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                })
                                _this.Refresh()
                            }
                        })
                        .catch(function (error) {})
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        downExcel() {
            /* 从表生成工作簿对象 */
            let fix = document.querySelector('.el-table__fixed')
            let wb
            var xlsxParam = { raw: true }
            if (fix) {
                //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#CloudData').removeChild(fix),
                    xlsxParam
                )
                document.querySelector('#CloudData').appendChild(fix)
            } else {
                wb = XLSX.utils.table_to_book(
                    document.querySelector('#CloudData'),
                    xlsxParam
                )
            }
            /* 获取二进制字符串作为输出 */
            var wbout = XLSX.write(wb, {
                bookType: 'xlsx',
                bookSST: true,
                type: 'array'
            })
            try {
                const fileName = this.moduleName + this.basicType + '.xlsx' //下载文件名称
                FileSaver.saveAs(
                    new Blob([wbout], { type: 'application/octet-stream' }),
                    //设置导出文件名称
                    fileName
                )
            } catch (e) {
                if (typeof console !== 'undefined') console.log(e, wbout)
            }
            return wbout
        },
        downLoadExcel() {
            const _this = this
            AjaxHelper.post(this.downLoadExcelUrl, this.FinQueryParams)
                .then((res) => {
                    if (res.success) {
                        _this.basicCloudData = res.result
                        if (_this.basicCloudData.length <= 0) {
                            _this.$notify({
                                title: '提示',
                                message: '当前无可导出的数据',
                                type: 'error',
                                position: 'bottom-right'
                            })
                            return false
                        } else {
                            _this.$nextTick(function () {
                                _this.downExcel()
                            })
                        }
                    }
                })
                .catch(function (error) {})
        },
        downloadFile(name) {
            let requestConfig = {
                headers: {
                    'Content-Type': 'application/json;application/octet-stream'
                }
            }
            AjaxHelper.post(
                this.downLoadUrl + '?typeName=' + name,
                requestConfig,
                {
                    responseType: 'blob'
                }
            ).then((res) => {
                // 处理返回的文件流
                const content = res
                const blob = new Blob([content])
                var date =
                    new Date().getFullYear() +
                    '' +
                    (new Date().getMonth() + 1) +
                    '' +
                    new Date().getDate()
                const fileName = date + name + '.xlsx'
                if ('download' in document.createElement('a')) {
                    // 非IE下载
                    const elink = document.createElement('a')
                    elink.download = fileName
                    elink.style.display = 'none'
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink)
                    elink.click()
                    URL.revokeObjectURL(elink.href) // 释放URL 对象
                    document.body.removeChild(elink)
                } else {
                    // IE10+下载
                    navigator.msSaveBlob(blob, fileName)
                }
            })
        },
        importFile() {
            this.$refs.refFileUpload.open()
        }
    }
}
</script>
